import React, { useMemo, useState } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import Close from "../../icons/Close";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { Box, Flex } from "rebass";
import Fallback from "../../icons/Fallback";

const ExpandImage = ({ onClose, imgs }) => {
  const [index, setIndex] = useState(0);
  const MAX_LENGTH = useMemo(() => imgs.length - 1, [imgs]);

  function previousPic() {
    if (index === 0) return;
    setIndex((i) => i - 1);
  }

  function nextPic() {
    if (index === MAX_LENGTH) return;
    setIndex((i) => i + 1);
  }

  const displayedImageSrc = useMemo(() => {
    const img = imgs[index];
    if (typeof img === "string") return img;
    else return img?.link || null;
  }, [imgs, index]);

  return (
    <Flex
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, .2)",
        zIndex: 9999,
        position: "fixed",
        top: 0,
        left: 0,
      }}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Flex
        sx={{
          width: ["100%", "87%"],
          backgroundColor: "white",
          borderRadius: [0, "20px"],
          height: ["100%", "80%"],
          position: "relative",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Flex justifyContent="center" sx={{ width: "100%" }}>
          {imgs?.length > 1 && (
            <>
              <AiOutlineLeft
                size="32px"
                onClick={previousPic}
                style={{
                  position: "fixed",
                  top: "28rem",
                  left: "0px",
                  zIndex: 2,
                }}
              />
              <AiOutlineRight
                size="32px"
                onClick={nextPic}
                height="100%"
                style={{
                  position: "fixed",
                  top: "28rem",
                  right: "15px",
                  zIndex: 2,
                }}
              />
            </>
          )}
          {displayedImageSrc ? (
            <TransformWrapper>
              <TransformComponent>
                <img
                  src={displayedImageSrc}
                  alt=""
                  style={{
                    width: "78vw",
                    height: "100%",
                    objectFit: "scale-down",
                    pointerEvents: "none",
                  }}
                />
              </TransformComponent>
            </TransformWrapper>
          ) : (
            <Fallback />
          )}
          <Box
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              cursor: "pointer",
            }}
          >
            <Close />
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ExpandImage;
